import React from "react";
import PropTypes from "prop-types";

function Input({
  label = "",
  isRequired = false,
  type = "text",
  placeholder = "",
  errorMessage = "",
  name = "",
  register = () => {},
  registerArgs = {},
  containerClassName = "flex flex-col sm-max:grid sm-max:w-full gap-[10px]",
  labelClassName = "text-white font-semibold text-[16px] not-italic font-normal",
  inputClassName = "",
  autoFocus = false,
  inputMode,
  value,
  onChange,
  min = 0,
  step = 0.001,
  readOnly = false,
  isDisabled = false,
  onKeyDown = () => {},
  icon = null,
}) {
  const handleWheel = (event) => event.target.blur();

  const inputProps = {
    autoFocus,
    name,
    ...register(name, { ...registerArgs }),
    ...(inputMode && { inputMode }),
    ...(value !== undefined && value !== null && { value }),
    ...(onChange && { onChange, onWheel: handleWheel }),
    readOnly,
    disabled: isDisabled,
    ...(Number.isFinite(min) && { min }),
    ...(step && { step }),
    placeholder,
    type,
    onKeyDown,
    className: inputClassName
      ? inputClassName
      : `flex h-[43px] items-center gap-[8px] self-stretch rounded-[6px] border-[1px] border-solid ${
          errorMessage && isRequired ? "border-red" : "border-default-color"
        } border-default-color bg-transparent outline-none text-white font-regular text-[16px] not-italic font-normal  placeholder:font-regular placeholder:text-[16px] placeholder:not-italic placeholder:font-normal py-[16px] px-[14px] opacity-[0.65]`,
  };

  return (
    <div className={containerClassName}>
      {label && (
        <div className={labelClassName}>
          {label} {isRequired && <span className="text-red">*</span>}
        </div>
      )}
      {icon ? (
        <div className={"relative w-full"}>
          <input {...inputProps} />
          <div className="absolute right-3 top-1/2 -translate-y-1/2">
            {icon}
          </div>
        </div>
      ) : (
        <input {...inputProps} />
      )}

      {errorMessage && isRequired && (
        <span className="text-[12px] text-red font-regular">
          {errorMessage}
        </span>
      )}
    </div>
  );
}

Input.propTypes = {
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  errorMessage: PropTypes.string,
  name: PropTypes.string,
  register: PropTypes.func,
  registerArgs: PropTypes.object,
  containerClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  autoFocus: PropTypes.bool,
  inputMode: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  min: PropTypes.number,
  step: PropTypes.number,
  onKeyDown: PropTypes.func,
  isDisabled: PropTypes.bool,
  icon: PropTypes.node,
};

export default Input;
